import React, {
  createContext,
  memo,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from "react";

const GradeLevelsChangesContext = createContext();

const GradeLevelsChangesProvider = memo(({ children }) => {
  const studentsMergedDataRef = useRef(new Map());

  const [allUpdated, setAllUpdated] = useState(new Map());
  const [allRemoved, setAllRemoved] = useState(new Map());
  const [allAdded, setAllAdded] = useState(new Map());
  const [allErrors, setAllErrors] = useState(new Map());

  const resetAllChanges = useCallback(() => {
    setAllUpdated(new Map());
    setAllRemoved(new Map());
    setAllAdded(new Map());
    setAllErrors(new Map());
  }, []);

  const value = useMemo(
    () => ({
      allUpdated,
      setAllUpdated,
      studentsMergedDataRef,
      allRemoved,
      setAllRemoved,
      allAdded,
      setAllAdded,
      resetAllChanges,
      allErrors,
      setAllErrors,
    }),
    [allUpdated, allRemoved, allAdded, resetAllChanges, allErrors]
  );

  return (
    <GradeLevelsChangesContext.Provider value={value}>
      {children}
    </GradeLevelsChangesContext.Provider>
  );
});

GradeLevelsChangesProvider.displayName = "GradeLevelsChangesProvider";
const useGradeLevelsChangesContext = () =>
  useContext(GradeLevelsChangesContext);

export { GradeLevelsChangesProvider, useGradeLevelsChangesContext };
